import { useEffect } from 'react';

export const useOnUnmount = (effect: () => void): void => {
    useEffect(() => {
        return () => {
            effect();
        };
    }, []);
};
